// LIVE-03（SPEC vms-web「客戶端解碼預算」）：超過解碼預算的格子標「預覽」並以快照每 5 秒更新。
// 快照 = 這台（通道各自算）最新的事件快照（GET …/vms/devices/{d}/snapshots/latest，SPEC #events-snapshot）；
// 沒有快照（404 NO_SNAPSHOT）就照舊只顯示「預覽」字樣。簽名網址短效（企業家戶 20 秒），每次重抓都拿新的。
import { useQuery } from '@tanstack/react-query';
import { useTranslation } from 'react-i18next';
import { KinioError } from '@kinio/web-sdk';
import { deviceApi } from '../../lib/deviceApi';
import type { VmsDevice } from '../../lib/devices';
import { timeStamp } from '../../lib/timefmt';

export const PREVIEW_REFRESH_MS = 5000;

export function PreviewSnapshot({ cam }: { cam: Pick<VmsDevice, 'apiEndpoint' | 'homeId' | 'aid'> }) {
  const { t } = useTranslation();
  const q = useQuery({
    // 含 apiEndpoint：不同 plane 的同一組 home / 設備 id 不共用快取
    queryKey: ['preview-snapshot', cam.apiEndpoint, cam.homeId, cam.aid],
    // 沒有快照（404）是正常結果 = null：先前抓到的那張要拿掉，不能因為背景重抓失敗而一直留著舊圖
    queryFn: () =>
      deviceApi.latestSnapshot(cam.apiEndpoint, cam.homeId, cam.aid).catch((e) => {
        if (e instanceof KinioError && e.status === 404) return null;
        throw e;
      }),
    refetchInterval: PREVIEW_REFRESH_MS,
    retry: false,
  });
  if (!q.data?.url) return null;
  return (
    <>
      <img className="tile-snap" src={q.data.url} alt="" data-testid="tile-snapshot" />
      {q.data.captured_at && (
        <div className="tile-snap-at small" data-testid="tile-snapshot-at">
          {t('live.snapshot_at', { at: timeStamp(q.data.captured_at) })}
        </div>
      )}
    </>
  );
}
